const SUBCONTRACTOR_STATUSES = {
  ACTIVE: "active",
  INVITE_SENT: "invite sent",
  SUSPENDED: "suspended",
  NO_ACCESS: "no access"
}

const subcontractorStatusOptions = [
  { label: "Active", value: SUBCONTRACTOR_STATUSES.ACTIVE },
  { label: "Invite Sent", value: SUBCONTRACTOR_STATUSES.INVITE_SENT },
  { label: "Suspended", value: SUBCONTRACTOR_STATUSES.SUSPENDED },
  { label: "No Access", value: SUBCONTRACTOR_STATUSES.NO_ACCESS }
]

const subcontractorStatusColorMap = {
  [SUBCONTRACTOR_STATUSES.ACTIVE]: "green",
  [SUBCONTRACTOR_STATUSES.INVITE_SENT]: "gold",
  [SUBCONTRACTOR_STATUSES.SUSPENDED]: "red",
  [SUBCONTRACTOR_STATUSES.NO_ACCESS]: "default"
}

const subcontractorEditableStatuses = [
  SUBCONTRACTOR_STATUSES.NO_ACCESS,
  SUBCONTRACTOR_STATUSES.INVITE_SENT
]

// EAD-1322 (Chen's design review, Screen 01): "No Access" read like the
// viewer's own permission was denied. This is a display-only relabeling of
// the same four statuses — the wire values, the color map and the filter
// options above are all unchanged — shown wherever the status is presented
// as a standalone label (the profile header, the list's status column)
// rather than in a picker where neighboring options already give it context.
const subcontractorPortalAccessLabels = {
  [SUBCONTRACTOR_STATUSES.NO_ACCESS]: "Not invited",
  [SUBCONTRACTOR_STATUSES.INVITE_SENT]: "Invitation pending",
  [SUBCONTRACTOR_STATUSES.ACTIVE]: "Enabled",
  [SUBCONTRACTOR_STATUSES.SUSPENDED]: "Suspended"
}

export {
  SUBCONTRACTOR_STATUSES,
  subcontractorStatusOptions,
  subcontractorStatusColorMap,
  subcontractorEditableStatuses,
  subcontractorPortalAccessLabels
}
